export const HEADER_SHORT_HEIGHT = '72px';
export const HEADER_SHORT_MOBILE_HEIGHT = '74px';
export const HEADER_DEFAULT_HEIGHT = '162px';
export const HEADER_DEFAULT_MOBILE_HEIGHT = '116px';
export const HEADER_DEFAULT_MENU_HEIGHT = '54px';
export const HEADER_SHORT_MENU_HEIGHT = '74px';
export const CONNECTED_BANNER_HEIGHT = '32px';

export const HEADER_TRANSITION = '0.7s';
